export default "__VITE_ASSET__DcQwhhd3__"